import { Subscription } from 'rxjs';
import { Component, OnInit, OnDestroy } from '@angular/core';
import { SectorModel } from '../../service/sector.model';
import { ConfirmdeleteComponent } from './../../service/confirmdelete/confirmdelete.component';
// import { DialogService } from 'ng2-bootstrap-modal';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { DBConnectorService } from '../../service/test.service';
import { LoggedInGuard } from '../../authentication/logged-in.guard';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';

@Component({
  selector: 'app-rules',
  templateUrl: './rules.component.html',
  styleUrls: ['./rules.component.css']
})
export class RulesComponent implements OnInit, OnDestroy {
  bsModalRef: BsModalRef;
  public categoryrules = [];
  public ruleslist = [];
  result: any = {};
  public rule_id: string;
  rule_condition: string;
  public rule_category = '';
  addedruleitem = [];
  labelsdisplay = [];
  newrulelist = [];
  rulecondition = [];
  rulelabel_name = [];
  sectormodel = new SectorModel;
  Sub: Subscription;
  public RulesXml: string;
  public RulesDescription: string;
  public rulesMapping = [];
  rule_MappingID: string;
  isValidated: boolean;
  ruleFormvalidationMessage: string;

  constructor(private dbconnectorservice: DBConnectorService, private http: HttpClient,
    private _dialogService: BsModalService,
    private loggedInGuard: LoggedInGuard) {
    this.sectormodel.SectorName = this.dbconnectorservice.SectorName;
    this.sectormodel.ModelName = this.dbconnectorservice.ModelName;
    this.dbconnectorservice.onGetSec.subscribe((res) => { this.sectormodel.SectorName = res; });
    this.Sub = this.dbconnectorservice.onGetMod.subscribe((res) => {
      this.sectormodel.ModelName = res;
      this.callIndex();
    });
  }

  callIndex() {
    if (this.sectormodel.SectorName != null && this.sectormodel.SectorName !== 'null') {
      this.result = {};
      this.ruleslist = [];
      const apiUrl = '/api/Config/Index';
      this.http.post<any>(apiUrl, this.sectormodel)
        .subscribe(data => {
          this.result = data;
          this.callCategoryArray();
          this.GetRule();
          if (this.result['RuleError'] == null) {
            this.labelsdisplay = this.result['Labels'];
            this.callRulesArray();
          }
        });
    } else {
      this.result['RuleError'] = 'Sector and Model have not been selected!';
    }
  }

  callRefresh() {
    if (this.loggedInGuard.isSessionValid()) {
      const apiUrl = '/api/Config/refreshCategories';
      this.http.post<any>(apiUrl, this.sectormodel)
        .subscribe(data => {
          this.result = data;
          console.log(data);
          this.callCategoryArray();
          this.GetRule();
        });
    }
  }

  callCategoryArray() {
    this.categoryrules = [];
    const apiUrl = '/api/Config/GetCategory';
    this.http.post<any>(apiUrl, { 'SectorName': this.dbconnectorservice.SectorName })
      .subscribe(data => {
        this.categoryrules = data;
      });
  }


  ApplyRules() {

    // const subrulearray =[]

    const SubRuledata = [];
    let desc = '';


    // console.log('Subrule array2-',this.newrulelist);
    // tslint:disable-next-line:forin
    for (const item in this.newrulelist) {
      if (Number(item) === 0) {
        desc = this.newrulelist[item]['Label_Name'] + ' contains ' + this.newrulelist[item]['Input_text']
      } else {
        desc = desc + ' ' + this.rule_condition + ' ' + this.newrulelist[item]['Label_Name'] + ' contains ' + this.newrulelist[item]['Input_text']
      }

      const data = {};
      // const SubRuledata={}
      data['Label_Name'] = this.newrulelist[item]['Label_Name'];
      data['Condition'] = this.newrulelist[item]['Condition'];
      data['Input_text'] = this.newrulelist[item]['Input_text'];
      // console.log('data array-',data);
      SubRuledata.push({ 'SubRule': data, 'rule_ID': Number(item) + 1 });
      // SubRuledata['SubRule']=data
      // SubRuledata['rule_ID']=i
    }
    console.log('desc', desc);

    const subrulearray = {
      'Rule': this.rule_condition,
      'rule_ID': this.rule_id,
      'Category': this.rule_category,
      'SubRuleList': SubRuledata
    };

    // subrulearray.push({
    //   'Rule':this.rule_condition,
    //   'rule_ID':this.rule_id,
    //   'Category':this.rule_category,
    //   'SubRuleList':SubRuledata

    // })

    // console.log('Subrule array-',subrulearray);
    // console.log('Subrulelist-',SubRuledata);

    const datapushed = {
      'SectorName': this.dbconnectorservice.SectorName,
      'ModelName': this.dbconnectorservice.ModelName,
      'ruleid': this.rule_id,
      'target': this.rule_category,
      'RuleContent': subrulearray,
      'desc': desc
    };

    const apiUrl = '/api/Config/DbInsertData';
    this.http.post<any>(apiUrl, datapushed)
      .subscribe(data => {
        this.callRulesArray();
      });

    this.ResetRulesFunction();
    this.rule_id = '';
  }


  AddFunction() {
    this.newrulelist.push(
      {
        'Label_Name': '',
        'Condition': '',
        'Input_text': '',

      });

  }

  ResetRulesFunction() {
    this.newrulelist = [];
    this.AddFunction();
  }

  callRulesArray() {

    const data = {

      'SectorName': this.dbconnectorservice.SectorName,
      'Model': this.dbconnectorservice.ModelName

    };
    const apiUrl = '/api/Config/GetRules';
    this.http.post<any>(apiUrl, data)
      .subscribe(data => {
        this.ruleslist = data;
      });
  }

  showConfirm(ruledelete: JSON) {
    this.bsModalRef = this._dialogService.show(ConfirmdeleteComponent);
    this.bsModalRef.content.event.subscribe(isConfirmed => {
      if(isConfirmed) 
        this.RuleDelete(ruledelete);
    })
    // const disposable = this.dialogService.addDialog(ConfirmdeleteComponent, {})
    //   .subscribe((isConfirmed) => {
    //     // We get dialog result
    //     if (isConfirmed) {
    //       this.RuleDelete(ruledelete);
    //     } else {
    //       // alert('declined');
    //     }
    //   });
  }

  RuleDelete(ruledelete: JSON) {
    const apiUrl = '/api/Config/DeleteConfirmed';
    this.http.post<any>(apiUrl, ruledelete)
      .subscribe(data => {
        console.log('Delete rule successfull');
        this.callRulesArray();

      });
  }

  //zone.js:2969 POST http://localhost:5000/api/Config/InsertRuleXml
  SendRules() {
    if (this.loggedInGuard.isSessionValid()) {
      const isRuleFormValidated = this.ValidateRuleForm();
      if (this.isValidated) {
        const RuleXml = this.RulesXml;
        const options = {
          headers: new HttpHeaders({
            'Content-Type': 'application/json'
          })
        }

        const dataModel = {
          RuleMappingID: this.rule_MappingID,
          RuleId: this.rule_id,
          SectorName: this.sectormodel.SectorName,
          TargetLabel: this.rule_category,
          RuleXml: JSON.stringify(RuleXml),
          Description: this.RulesDescription
        };

        const apiUrl = '/api/Config/InsertRuleXml';
        this.http.post<any>(apiUrl, dataModel, options)
          .subscribe(data => {
            console.log('Xml rule successfull');
            this.ruleslist = data;
            this.GetRule();
            if ((data === '') && (data.status === 202)) {
              this.rule_id = '';
              this.rule_MappingID = '';
              this.rule_category = '';
              this.RulesXml = '';
              this.RulesDescription = '';
              alert(' Rule saved successfully ');
            } else {
              alert(data);
            }

          });
      } else {
        return false;
      }
    }
  }

  ValidateRuleForm() {
    this.isValidated = true;
    this.ruleFormvalidationMessage = '';

    // variables
    const ruleID = this.rule_id;
    const sectorName = this.sectormodel.SectorName;
    const ruleCategory = this.rule_category;
    const ruleDescription = this.RulesDescription;
    const ruleXML = this.RulesXml;

    if (ruleID == null) {
      this.isValidated = false;
      this.ruleFormvalidationMessage = 'Please enter Rule Name';
      return false;
    }
    if ((sectorName == null) || (sectorName === '')) {
      this.isValidated = false;
      this.ruleFormvalidationMessage = 'Please select Sector and Model';
      return false;
    }
    if ((ruleCategory == null) || (ruleCategory === '')) {
      this.isValidated = false;
      this.ruleFormvalidationMessage = 'Please select category';
      return false;
    }
    if ((ruleDescription == null) || (ruleDescription === '')) {
      this.isValidated = false;
      this.ruleFormvalidationMessage = 'Please provide description  ';
      return false;
    }
    if ((ruleXML == null) || (ruleXML === '')) {
      this.isValidated = false;
      this.ruleFormvalidationMessage = 'Please provide "Rule XML"  ';
      return false;
    } else {
      this.isValidated = true;
      this.ruleFormvalidationMessage = '';
    }
    return this.isValidated;

    // RuleXml:JSON.stringify(RuleXml),Description:this.RulesDescription};
  }

  GetRule() {
    if (this.loggedInGuard.isSessionValid()) {
      this.rulesMapping = [];
      const apiUrl = '/api/Config/GetAllRules';
      this.http.post<any>(apiUrl, { 'SectorName': this.dbconnectorservice.SectorName })
        .subscribe(data => {
          this.rulesMapping = data;
        });
    }
  }

  AddNewRules() {
    // reset the selection
    this.rule_id = '';
    this.rule_MappingID = '';
    this.rule_category = '';
    this.RulesXml = '';
    this.RulesDescription = '';

  }
  onRuleIDChange(newValue) {
    if (this.loggedInGuard.isSessionValid()) {
      const ruleIDMapping = this.rule_MappingID;
      this.rule_id = '';
      this.rule_category = '';
      this.RulesXml = '';
      this.RulesDescription = '';

      if (this.rule_MappingID.length === 0) {

        // insert
        //    this.rule_id
        //  this.sectormodel.SectorName
        //  this.rule_category
        //  this.RulesXml
        //  this.RulesDescription
      } else {

        this.rulesMapping.forEach((value) => {
          if (value.RuleMappingID.toString() === ruleIDMapping) {
            this.rule_id = value.RuleId;
            // this.sectormodel.SectorName
            this.rule_category = value.TargetLabel;
            this.RulesXml = value.RuleContent;
            this.RulesDescription = value.Description;
          }
        });


        //   this.rulesMapping.forEach(function (value) {
        //     if(value.RuleMappingID.toString()==ruleIDMapping){
        //        this.rule_id=value.RuleId;
        //        //this.sectormodel.SectorName
        //        this.rule_category =value.TargetLabel;
        //        this.RulesXml=value.RuleContent;
        //        this.RulesDescription=value.Description;
        //     }
        //  });

      }
    }

    // do the foreach and populate the below object
    // this.rule_id
    // this.sectormodel.SectorName
    // this.rule_category
    // this.RulesXml
    // this.RulesDescription


  }

  deleteRule() {
    if (this.loggedInGuard.isSessionValid()) {

      // deleteRule Start
      const ruleID = this.rule_id;
      if (ruleID == null) {
        this.isValidated = false;
        this.ruleFormvalidationMessage = 'Please select rule';
        return false;
      } else {
        // call the service and pass this id 

        const options = {
          headers: new HttpHeaders({
            'Content-Type': 'application/json'
          })
        }
        const dataModel = { RuleMappingID: this.rule_MappingID, ruleID: ruleID };
        // let dataModel={RuleId:JSON.stringify(this.rule_id),SectorName:JSON.stringify(this.sectormodel.SectorName),TargetLabel:JSON.stringify(this.rule_category),RuleXml:JSON.stringify(RuleXml),Description:JSON.stringify(this.RulesDescription)};
        const apiUrl = '/api/Config/DeleteRuleXml';
        this.http.post<any>(apiUrl, dataModel, options)
          .subscribe(data => {
            console.log('Delete' + ruleID + ' rule  successfull');
            this.ruleslist = data;
            this.GetRule();
            if ((data.status === 200)) {
              this.rule_id = '';
              this.rule_MappingID = '';
              this.rule_category = '';
              this.RulesXml = '';
              this.RulesDescription = '';
              // this.GetRule();
              alert(' Rule deleted successfully ');
            } else {
              alert(data);
            }

          });

      }

      // deleteRule End
    }
  }

  ngOnInit() {
    this.callIndex();
    this.AddFunction();
    // console.log(this.newrulelist)
  }

  ngOnDestroy() {
    if (this.Sub != null) {
      this.Sub.unsubscribe();
    }
  }
}
